import { html } from "lit";
var icon_campaignActive_default = () => html`
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.75 3.125c0-1.036.84-1.875 1.875-1.875h2.977c.292 0 .579.068.839.198L11.546 2.5h2.829c.999 0 1.815.78 1.872 1.765l.003.11v6.25c0 1.036-.84 1.875-1.875 1.875h-2.977c-.292 0-.579-.068-.839-.198L8.455 11.25h-2.83c-.219 0-.43-.038-.625-.107v6.982H3.75z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_campaignActive_default as default
};
//# sourceMappingURL=icon-campaignActive.js.map
